import { useEffect } from "react";
import { setupAppPageBodyBackground } from "../game/gameStageBackground";
import { BACKGROUNDS } from "./desiAssets";

/** Old index-bg.jpg (desktop) / mobbg.jpg (phones) page backdrop. */
export default function useDesiBackground(
  deskForeground = BACKGROUNDS.desk,
  mobForeground = BACKGROUNDS.mob
) {
  useEffect(
    () =>
      setupAppPageBodyBackground(document.body, {
        deskForeground,
        mobForeground,
      }),
    [deskForeground, mobForeground]
  );
}
